import React from "react";
import type { PainelBordeiroSemana } from "../../../../services/painelBordeiroService";
import { formatDiaMes } from "../../../PainelBordeiro/utils";
import { useTvAutoScroll } from "../hooks/useTvAutoScroll";
import { CLASSE_ROLAGEM_TV } from "./TvTabelaDia";

type Props = { dados: PainelBordeiroSemana };

const TH =
  "whitespace-nowrap px-2 py-3 text-center text-[clamp(0.7rem,1.2vw,1.4rem)] font-bold uppercase tracking-wide lg:px-4";
const TD =
  "whitespace-nowrap px-2 py-[clamp(0.35rem,1vh,1rem)] text-center text-[clamp(1.1rem,2.4vw,3.25rem)] font-black tabular-nums leading-none lg:px-4";
const HOJE = "border-x border-emerald-300/50 bg-emerald-800/60";

const TvTabelaSemana: React.FC<Props> = ({ dados }) => {
  const listaRef = useTvAutoScroll(
    dados.bordas.map((b) => b.bordaChave).join("|")
  );
  return (
    <div className="flex max-h-full min-h-0 w-full flex-col overflow-hidden rounded-xl border border-white/20 bg-white/10 backdrop-blur-sm">
      <div ref={listaRef} className={CLASSE_ROLAGEM_TV}>
        <table className="w-full divide-y divide-white/10">
          <thead className="sticky top-0 z-10 bg-red-950/90 backdrop-blur-sm">
            <tr>
              <th className={`${TH} text-left text-white/85`}>Borda</th>
              {dados.dias.map((d) => (
                <th
                  key={d.data}
                  className={`${TH} ${d.data === dados.hoje ? `${HOJE} text-white` : "text-white/80"}`}
                >
                  {d.diaSemana.slice(0, 3)}
                  <span className="block text-[0.75em] font-medium normal-case text-white/60">
                    {formatDiaMes(d.data)}
                  </span>
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-white/10">
            {dados.bordas.map((b) => (
              <tr key={b.bordaChave}>
                <td className="px-2 py-[clamp(0.35rem,1vh,1rem)] text-[clamp(1rem,2vw,2.75rem)] font-extrabold leading-tight lg:px-4">
                  {b.bordaNome}
                </td>
                {dados.dias.map((d) => {
                  const c = b.dias[d.data];
                  const valor = c?.planejada ?? c?.sugerida ?? 0;
                  return (
                    <td
                      key={d.data}
                      className={`${TD} ${d.data === dados.hoje ? HOJE : ""} ${
                        c?.planejada != null
                          ? "text-yellow-300"
                          : "text-white/85"
                      }`}
                    >
                      {valor}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
          <tfoot className="border-t-2 border-white/30 bg-black/25">
            <tr>
              <td className="px-2 py-3 text-[clamp(1rem,2vw,2.75rem)] font-extrabold uppercase lg:px-4">
                Total
              </td>
              {dados.dias.map((d) => (
                <td
                  key={d.data}
                  className={`${TD} ${d.data === dados.hoje ? HOJE : ""} ${
                    d.totalPlanejada != null ? "text-yellow-300" : ""
                  }`}
                >
                  {d.totalPlanejada ?? d.totalSugerida}
                </td>
              ))}
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

export default TvTabelaSemana;
